import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OENoteStateProvider extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = typeof(this.props.id) === 'number' ? this.props.id : null;

        this.noteState = OENoteStateProvider.defaultNoteState();

        this.onNoteStyleChanged = this.onNoteStyleChanged.bind(this);
        this.onIsInDocumentChanged = this.onIsInDocumentChanged.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id !== this.props.id)     {
            this.id = typeof(nextProps.id) === 'number' ? nextProps.id : null;
            this.updateNoteState(true);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteStyleChanged, this.onNoteStyleChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteIsInDocumentChanged, this.onIsInDocumentChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteStyleChanged, this.onNoteStyleChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteIsInDocumentChanged, this.onIsInDocumentChanged);
    }

    updateNoteStyle(style, defColor, mute = false)  {
        if((!this.oe.isReady() || this.id === null) && !style)    return;

        let style_ = style || this.oe.sharedInterface.getUIControllerNote().getNoteStyle(this.id);

        let newState = clone(this.noteState);
        newState.style = {
            hAlignment: style_.hAlignment.value,
            vAlignment: style_.vAlignment.value,
            padding: style_.padding,
            cornerRadius: style_.cornerRadius,
            textColor: style_.textColor,
            backgroundColor: style_.backgroundColor,
            borderColor: style_.borderColor,
            lineColor: style_.lineColor,
            hasBorder: style_.hasBorder,
            fontSize: style_.fontSize,
            showAlways: style_.showAlways,
            maxWidth: Math.max(0, style_.maxWidth),
            linkPointSize: style_.linkPointSize
        };
        
        if(defColor)    {
            newState.defaultTextColor = style_.textColor;
            newState.defaultLineColor = style_.lineColor;
            newState.defaultBorderColor = style_.borderColor;
            newState.defaultBackgroundColor = style_.backgroundColor;
        }

        if(OEToolbox.shallowEqual(this.noteState, newState, true))  return;

        this.noteState = newState;

        if(!mute && this.props.onNoteStateChanged)   this.props.onNoteStateChanged(this, newState);
    }

    updateIsInDocument(isInDocument, mute = false)    {
        if((!this.oe.isReady() || this.id === null) && typeof(isInDocument) !== 'boolean')    return;

        isInDocument = typeof(isInDocument) === 'boolean' ? isInDocument : this.oe.sharedInterface.getUIControllerNote().getNoteIsInDocument(this.id);

        if(this.noteState.isInDocument === isInDocument)    return;

        this.noteState.isInDocument = isInDocument;

        if(!mute && this.props.onNoteStateChanged)   this.props.onNoteStateChanged(this, this.noteState);
    }

    updateNoteState(defColor)   {
        let oldState = clone(this.noteState);
        this.updateNoteStyle(null, defColor, true);
        this.updateIsInDocument(null, true);
        if(OEToolbox.shallowEqual(this.noteState, oldState, true))  return;
        if(this.props.onNoteStateChanged)   this.props.onNoteStateChanged(this, this.noteState);
    }

    onNoteStyleChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteStyle(userInfo.style);
    }

    onIsInDocumentChanged(message, userInfo) {
        if(userInfo.ID !== this.id)  return;
        this.updateIsInDocument(userInfo.isInDocument);
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateNoteState(true);
    }

    render()    {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
            </React.Fragment>
        )
    }
}

OENoteStateProvider.defaultNoteState = function()   {
    return {
        style: {
            hAlignment: 0,
            vAlignment: 0,
            padding: {x: 16, y: 16, z: 16, w: 16},
            cornerRadius: 16,
            textColor: {x: 0, y: 0, z: 0, w: 1},
            backgroundColor: {x: 1, y: 1, z: 1, w: 1},
            borderColor: {x: 0, y: 0, z: 0, w: 1},
            lineColor: {x: 0, y: 0, z: 0, w: 1},
            hasBorder: true,
            fontSize: 16,
            showAlways: false,
            maxWidth: 0,
            linkPointSize: 5
        },
        isInDocument: false,
        defaultTextColor: {x: 0, y: 0, z: 0, w: 1},
        defaultBackgroundColor: {x: 1, y: 1, z: 1, w: 1},
        defaultBorderColor: {x: 0, y: 0, z: 0, w: 1},
        defaultLineColor: {x: 0, y: 0, z: 0, w: 1}
    };
};

OENoteStateProvider.defaultProps = {
    moduleId: ''
};

OENoteStateProvider.propTypes = {
    moduleId: PropTypes.string,
    id: PropTypes.number,
    onNoteStateChanged: PropTypes.func
};